import React, {useState,useEffect} from 'react';
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { navigate } from "@reach/router"
import db from '../firebase'

const ArtsStatus = (props) => {
    


    const [token_input, setTokenInput] = useState('')
    const onTokenInputChange = (event) => {setTokenInput(event.target.value)}
    const onCheckToken = () =>{
        console.log("dasasd")
        let tokDef = db.collection('arts').doc(token_input)


        tokDef.get().then(function(doc) {
            if (doc.exists) {                
                let data = doc.data()
                let token = doc.id
                let myServiceRequest = {
                    token,
                    ...data
                }
                setHasToken(true)
                setToken(token)
                console.log("token idx", token)
                console.log("Document data:", myServiceRequest);
                setServiceinfo(myServiceRequest)
            } else {
                //doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

    };

    const [hastoken, setHasToken] = useState(false)
    const [token_number, setToken] = useState('')
    const [serviceinfo, setServiceinfo] = useState('')

    useEffect(() => {
        if(hastoken)
        {console.log("sdaasd");}
        else
        {
            let postRef = db.collection('arts').doc(props.id)

            postRef.get().then(function(doc) {
                if (doc.exists) {                
                    let data = doc.data()
                    let token = doc.id
                    let myServiceRequest = {
                        token,
                        ...data
                    }
                    setHasToken(true)
                    setToken(token)
                    console.log("token idx", token)
                    console.log("Document data:", myServiceRequest);
                    setServiceinfo(myServiceRequest)
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

        }
  
    }, [])
    

    return(
        <div className="page_container">
            <div className="create_post_container container special-card border-dark" style={{marginTop:"2rem" ,paddingTop:"1rem",  paddingBottom:"3rem"}}>
                
                 {
                    hastoken
                    ? 
                        <div className="has_token">
                                <div className="page_header_container">
                                    <h1 className="text-dark font-weight-bold">Application Status</h1>
                                    <hr className="mb-3 mt-0 border-info"/>
                                </div>
                                    
                                <div className="token_banner">
                                    <Alert  variant="success" className="h2">
                                        Your Application Number is <kbd>{token_number}</kbd>! Please save it for future
                                        reference. You may choose to bookmark this page or screenshot the token for your convenience.
                                        <br/>
                                        REMEMBER! You must mention your name and this application number when making the payment!
                                    </Alert>
                                </div>

                                <div className="service_order_status">
                                    <Card className="text-center">
                                        <Card.Header  className="border-success" as="h2">Welcome, {serviceinfo.name}</Card.Header>
                                        <Card.Body>
                                            <Card.Title>
                                                In order to complete the admission procedure, you have to make the payment of admission fees according to what is mentioned in the prospectus.
                                                Follow the following steps to complete the procedure.
                                                <br/>
                                               <strong>Step 1:</strong>  Copy/Note down the application number above.
                                                <br/> 
                                               <strong>Step 2:</strong> Check out the exact amount of fees required for your particular course(Major/General).
                                                <br/>
                                                <strong>Step 3:</strong> Open your choice of UPI app. We will show example using google pay.
                                                <br/>
                                                <strong>Step 4:</strong> Mention your name and application number while making the payment.
                                                <br/>
                                                <strong>Step 5:</strong> After payment wait for 1-2 days for confirmation of payment. Since we do manual confirmation of payment it might take 1-2 days for confirmation to be shown in this page.
                                            </Card.Title>
                                            <Card.Text>
                                             
                                            </Card.Text>
                                            <Card.Text>

                                            <Alert variant='success' className='text-left col-md-6 mx-auto'> 
                                                The details submitted by you are shown below:
                                             <br/>
                                                Your Name = {serviceinfo.name}<br />
                                                Father's Name = {serviceinfo.fathername}<br />
                                                Mother's Name = {serviceinfo.mothername}<br />
                                                Guardian's Name = {serviceinfo.guardianname}<br />
                                                Date of birth = {serviceinfo.dob}<br />
                                                Caste = {serviceinfo.caste}<br />
                                                Nationality = {serviceinfo.nationality}<br />
                                                Religion = {serviceinfo.religion}<br />
                                                Sex = {serviceinfo.sex}<br />
                                                Ward/Village = {serviceinfo.ward_permanent}<br />
                                                Postoffice = {serviceinfo.postoffice_permanent}<br />
                                                District = {serviceinfo.district_permanent}<br />
                                                State = {serviceinfo.state_permanent}<br />
                                                Pincode = {serviceinfo.pincode_permanent}<br />
                                                Phone Number = {serviceinfo.phone_permanent}<br />
                                                Landline Number = {serviceinfo.landline_permanent}<br />
                                                Previous School/College = {serviceinfo.school}<br />
                                                Registration Number of H.S Examination = {serviceinfo.regnumber}<br />
                                                Registration Year for H.S Examination = {serviceinfo.regyear}<br />
                                                Starting year of Gap in Studies = {serviceinfo.gapstart}<br />
                                                Ending year of Gap in Studies = {serviceinfo.gapend}<br />
                                                Serial Number of The H.S Marksheet = {serviceinfo.serial}<br />
                                                Roll oF H.S Examination = {serviceinfo.roll}<br />
                                                Roll-Number of H.S Examination= {serviceinfo.number}<br />
                                                Year of Attending H.S Examination = {serviceinfo.rollyear}<br />
                                                Total Marks Obtained in H.S Examination = {serviceinfo.totalobtained}<br />
                                                Division Obtained in H.S Examination = {serviceinfo.division}<br />
                                                Percentage Obtained in H.S Examination = {serviceinfo.percentage}<br />
                                                1st Preference of Subject = {serviceinfo.preference1}<br />
                                                2nd Preference of Subject = {serviceinfo.preference2}<br />
                                                Compulsory Subject Selected = {serviceinfo.compulsory}<br />
                                                Generic Elective Subjects Selected = {serviceinfo.electives}<br />
                                                Honours Subjects (Allowed in) = {serviceinfo.honours}<br />
                                                Core Course Subject 1 Selected (For Non Honours) = {serviceinfo.core1}<br />
                                                Core Course Subject 2 Selected (For Non Honours) = {serviceinfo.core2}<br />


                                               </Alert>


                                                <strong>Note: In a few days this page will be updated to allow you to upload your marksheets, certificates etc. At that time kindly upload the required documents.</strong> 
                                            </Card.Text>
                                        </Card.Body>
                                        <Card.Footer className="text-muted">2 days ago</Card.Footer>
                                    </Card>                                    
                                </div>
                        </div>
                    :
                        <div className="post_inputs_container">
                            <div className="post_input_container">
                            
                                <Form>
                                    <legend  className="h2 text-primary text-center">Provide Application Number to view Application Status (ARTS)</legend>

                                        <Form.Group as={Row} controlId="formPlaintextPassword">
                                            <Form.Label column="lg" sm="2" md="3" lg="3" >
                                                <span className="float-md-right">Application No.    :</span> 
                                            </Form.Label>
                                            <Col sm="6" md="6" lg="6">
                                                <Form.Control 
                                                    value={token_input} onChange={onTokenInputChange}    
                                                    size="lg" 
                                                    type="text" 
                                                    placeholder="APPLICATION NUMBER" />
                                            </Col>
                                            <Col sm="3" md="3" lg="3">
                                                <Button className="btn-lg mb-9" onClick={onCheckToken}>Submit</Button>
                                            </Col>
                                        </Form.Group>                 
                                </Form>

                            </div>                
                        </div>
                    }
                </div>           
        </div>
    )
}

export default ArtsStatus;